import { render, staticRenderFns } from "./Partition.vue?vue&type=template&id=0870495e"
import script from "./Partition.vue?vue&type=script&lang=js"
export * from "./Partition.vue?vue&type=script&lang=js"
import style0 from "./Partition.vue?vue&type=style&index=0&id=0870495e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports